export default __webpack_public_path__ + "src/images/galleries/1/sidebar_bg-068bef.png";